import { Routes } from '@angular/router';

export const ROLES_ROUTES: Routes = [
  {
    path: 'roles',
    loadComponent: () =>
      import('./roles-list/roles-list.component')
        .then(m => m.RolesListComponent),
  },
  {
    path: 'roles/create',
    loadComponent: () =>
      import('./roles-form/roles-form.component')
        .then(m => m.RolesFormComponent),
  },
  {
    path: 'roles/edit/:id',
    loadComponent: () =>
      import('./roles-form/roles-form.component')
        .then(m => m.RolesFormComponent),
  },
];
